import { injectGlobal } from 'styled-components'
import vars from 'li-components/lib/styles'

// eslint-disable-next-line no-unused-expressions
const globalStyles = `
  *:before,
  *:after,
  * {
    box-sizing: border-box;
  }

  html {
    font-size: 10px;
    overflow-x: hidden;
  }

  body {
    padding-top: 70px;
    overflow-x: hidden;
    color: ${vars.gray};
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  button,
  input[type='submit'] {
    cursor: pointer;
  }
`

export const injectGlobalStyles = () => injectGlobal`
  ${globalStyles}
`



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/styles.js